import { WC2026_EN_NORM_TO_HE } from '../data/worldCup2026TeamLookup';

/**
 * Team (Group) display names from API: nameHe, nameEn, legacy name fallback.
 * @param {{ name?: string, nameHe?: string, nameEn?: string } | null | undefined} team
 * @param {'en' | 'he'} language
 */
export function getTeamDisplayName(team, language) {
  if (!team) return '';
  const legacy = typeof team.name === 'string' ? team.name.trim() : '';
  if (language === 'en') {
    const en = typeof team.nameEn === 'string' ? team.nameEn.trim() : '';
    return en || legacy || '';
  }
  const he = typeof team.nameHe === 'string' ? team.nameHe.trim() : '';
  return he || legacy || '';
}

/** Strip smart quotes from CSV team cells. */
export function sanitizeCsvTeamIdentifier(value) {
  return String(value)
    .trim()
    .replace(/^[\u201c\u201d\u201e\u201f\u00ab\u00bb"']+|[\u201c\u201d\u201e\u201f\u00ab\u00bb"']+$/g, '');
}

/** Normalize team names for CSV import / search (Unicode, apostrophes, diacritics). */
export function normalizeTeamNameForMatch(value) {
  return sanitizeCsvTeamIdentifier(value)
    .normalize('NFC')
    .toLowerCase()
    .replace(/[\u2018\u2019\u201A\u201B\u2032\u2035`´']/g, '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

const TEAM_NAME_ALIASES = {
  turkey: 'turkiye',
  'ivory coast': 'cote divoire',
  'cote d ivoire': 'cote divoire',
  'democratic republic of the congo': 'congo dr',
  drcongo: 'congo dr',
  'south korea': 'korea republic',
  iran: 'ir iran',
};

/** Match CSV / search input against any stored name variant. */
export function teamMatchesName(team, query) {
  if (!team || query == null) return false;
  const q = normalizeTeamNameForMatch(query);
  if (!q) return false;
  const qAlias = TEAM_NAME_ALIASES[q] || q;
  const fields = [team.name, team.nameHe, team.nameEn];

  const fieldMatches = fields.some((f) => {
    if (typeof f !== 'string') return false;
    const trimmed = f.trim();
    if (trimmed.normalize('NFC') === sanitizeCsvTeamIdentifier(query).normalize('NFC')) {
      return true;
    }
    const normalized = normalizeTeamNameForMatch(f);
    return normalized === q || normalized === qAlias || TEAM_NAME_ALIASES[normalized] === qAlias;
  });
  if (fieldMatches) return true;

  const hebrewFromEn = WC2026_EN_NORM_TO_HE[q] || WC2026_EN_NORM_TO_HE[qAlias];
  if (!hebrewFromEn) return false;
  return fields.some((f) => typeof f === 'string' && f.trim() === hebrewFromEn);
}
